
export default function Services() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Residential Staging',
      description: 'Transform empty homes into warm, inviting spaces that help buyers envision their future. Perfect for apartments, houses, and condos.'
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial Spaces',
      description: 'Showcase office spaces, retail locations, and commercial properties with professional staging that highlights functionality and potential.'
    },
    {
      icon: 'ri-delete-bin-line',
      title: 'Furniture & Item Removal',
      description: 'Digitally remove unwanted furniture, clutter, or items from property photos to create clean, spacious images that appeal to buyers.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-[#F8F6F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm text-gray-500 mb-3 flex items-center justify-center gap-2">
            <span className="w-1.5 h-1.5 bg-gray-400 rounded-full"></span>
            OUR SERVICES
          </p>
          <h2 className="text-5xl md:text-6xl font-bold">
            Everything You Need
            <span className="block mt-2">To Showcase Properties</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-3xl p-10 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-5xl text-black`}></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
